import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'



const routes: RouteRecordRaw[] = [
  {
    path: '/',
    // redirect: '/task',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  ////////////////////////////
  // Pour faire des petits tests
  ////////////////////////////
  // {
  //   path: '/test',
  //   // redirect: '/task',
  //   name: 'test',
  //   component: () => import('../../test/components/TestColor.vue'),
  //   meta: { requiresAuth: false },
  // },

  {
    path: '/callback',
    name: 'Callback',
    component: () => import('../views/OidcCallback.vue'),
    meta: { requiresAuth: false },
  },

  {
    path: '/cabine/:id_cabine(\\d+)',
    children: [
      {
        path: '',
        name: 'cabine',
        props: true,
        beforeEnter(to) {
          location.href = import.meta.env.VITE_DASHBOARD_URL + `/cabine/${to.params.id_cabine}`
        },
        component: () => {},
      },
      {
        path: 'change',
        name: 'cabine_change',
        props: true,
        beforeEnter(to) {
          location.href =
            import.meta.env.VITE_DASHBOARD_URL + `/cabine/${to.params.id_cabine}/change`
        },
        component: () => {},
      },
    ],
  },

  {
    path: '/task',
    name: 'tasks',
    component: () => import('../tbb_intervention/views/TaskTable.vue'),
  },
  {
    path: '/task/:id_task(\\d+)',
    // name: 'task',
    // component: () => import ('../views/Task.vue'),
    children: [
      {
        path: '',
        name: 'task',
        props: true,
        component: () => import('../tbb_intervention/views/Task.vue'),
      },
      {
        path: 'procedure',
        name: 'procedure',
        props: true,
        component: () => import('../tbb_intervention/views/ProcedureRun.vue'),
      },
    ],
  },
  {
    path: '/call',
    name: 'call',
    component: () => import('../components/MakeCall.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not_found',
    component: () => import('../views/NotFound.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
